import PropTypes from "prop-types";
import React, { useState } from "react";
import Back from "../../assets/assets/back.svg";
import NipWrapper from "../../components/Nip/NipWrapper";
import { copyTextFunction } from "../../utils/Functions/copyTextFunction";
import truncateName from "../../utils/Functions/shortenStr";
import { useHistory } from "react-router-dom";

const Credentials = (props) => {
  const history = useHistory()

  const [state, setState] = useState({
    copied: false,
    index: "",
  });

  const bankCode = props.location.state && props.location.state.bankCode
  const wsdlUrl = props.location.state && props.location.state.wsdlUrl
  const acctNumber = props.location.state && props.location.state.acctNumber
  const myFunction = copyTextFunction(setState);

  const goBack = () => {
    history.goBack(-1)
  }

  return (
    <NipWrapper>
      <div className="live-env">
        <div onClick={goBack} className="live-env-back" data-testid="goBack">
          <img src={Back} alt="back" /> <span>Back</span>
        </div>
        <br />
        <div className="live-env-title">Credentials</div>
        <div className="live-env-sub-title">
          Run tests, requests and responses, make API Calls and perform other
          related activities.
        </div>
        <div className="live-env-info-box">
          <div className="live-env-info-box-wrapper">
            <div className="live-env-info-box-circle">i</div>
          </div>
          <div className="live-env-info-box-text">
            These credentials are for testing only. Please <span>DO NOT</span>{" "}
            use them in production.
          </div>
        </div>

        <div className="live-env-key">
          <div className="live-env-key-title">Bank Code</div>
          <div className="live-env-key-box">
            <span className="live-env-key-box-details">
              {bankCode || "No code available"}
            </span>
            {bankCode && (
              <span
                className="live-env-key-box-copy"
                data-testid="myFunction"
                onClick={() => myFunction(bankCode)}
              >
                {state.copied && state.index === bankCode ? "COPIED!" : "COPY"}
              </span>
            )}
          </div>
        </div>

        <div className="live-env-key">
          <div className="live-env-key-title">Wsdl URL</div>
          <div className="live-env-key-box">
            <span className="live-env-key-box-details">
              {truncateName(wsdlUrl) || "No url available"}
            </span>
            {wsdlUrl &&
              <span
                className="live-env-key-box-copy"
                data-testid="myFunction2"
                onClick={() => myFunction(wsdlUrl)}
              >
                {state.copied && state.index === wsdlUrl ? "COPIED!" : "COPY"}
              </span>
            }
          </div>
        </div>

        <div className="live-env-key">
          <div className="live-env-key-title">Account Number</div>
          <div className="live-env-key-box">
            <span className="live-env-key-box-details">
              {acctNumber || "No account number available"}
            </span>
            {acctNumber &&
              <span
                className="live-env-key-box-copy"
                data-testid="myFunction3"
                onClick={() => myFunction(acctNumber)}
              >
                {state.copied && state.index === acctNumber ? "COPIED!" : "COPY"}
              </span>
            }
          </div>
        </div>
      </div>
    </NipWrapper>
  );
};

Credentials.propTypes = {
  getKeys: PropTypes.func,
  isGettingKeys: PropTypes.any,
  kitKey: PropTypes.shape({
    public_key: PropTypes.any
  }),
  location: PropTypes.shape({
    state: PropTypes.shape({
      acctNumber: PropTypes.any,
      bankCode: PropTypes.any,
      wsdlUrl: PropTypes.any
    })
  })
}


export default Credentials;
